import { supabase } from '@/lib/supabase';

/**
 * Get the current Supabase session token for API authentication
 * @returns {Promise<string>} The access token
 * @throws {Error} If user is not authenticated
 */
export async function getAuthToken() {
  const { data: { session }, error } = await supabase.auth.getSession();
  
  if (error) {
    console.error('Error getting session:', error);
    throw new Error('Failed to get authentication token');
  }
  
  if (!session?.access_token) {
    throw new Error('Not authenticated. Please log in.');
  }
  
  console.log('Got auth token for user:', session.user?.email);
  return session.access_token;
}

/**
 * Make an authenticated fetch request to the backend API
 * @param {string} url - The URL to fetch
 * @param {RequestInit} options - Fetch options
 * @returns {Promise<Response>} The fetch response
 */
export async function authenticatedFetch(url, options = {}) {
  try {
    const token = await getAuthToken();
    
    console.log('Making authenticated request to:', url);
    
    const response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    console.log('Response status:', response.status);
    return response;
  } catch (error) {
    console.error('Authenticated fetch error:', error);
    throw error;
  }
}
